import isUndefined from 'lodash.isundefined';
import PropTypes from 'prop-types';
import React from 'react';
import LoadingArea from '@molecules/LoadingArea';
import useViewer from '@hooks/useViewer';

const ViewerLoadingWrapper = ({ children }) => {
    const { viewer } = useViewer();

    if (isUndefined(viewer)) {
        return <LoadingArea />;
    }

    return children;
};

ViewerLoadingWrapper.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ViewerLoadingWrapper;
